module.exports = ".phase-select {\n  color: black !important; }\n\n.phase-header-title {\n  font-size: smaller;\n  height: 40px; }\n\n.phase-header-num {\n  font-size: 300%;\n  height: 50px; }\n\n.content {\n  height: 100%;\n  height: 70vh;\n  margin-bottom: 15px;\n  overflow-y: auto;\n  overflow-x: hide;\n  -webkit-overflow-scrolling: touch; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/sessions/stats/stats.component.scss
// module id = ./src/app/modules/sessions/stats/stats.component.scss
// module chunks = main